import React from 'react';

import { useSelector } from 'react-redux';

import type { NormalizedReportItem } from '@modules/reports/basicReports/duck/utils';
import { isMobileSel } from '@shared/duck/selectors/general.selectors';

import SingleReportDeskop from './SingleReportDesktop';
import SingleReportMobile from './SingleReportMobile';

function SingleReport(props: {
  name: string;
  description?: string;
  openLabel?: JSX.Element | string;
  report?: NormalizedReportItem;
  noDivider?: boolean;
  onClick: () => void;
}) {
  const isMobile = useSelector(isMobileSel);

  const ReportComponent = isMobile ? SingleReportMobile : SingleReportDeskop;
  return <ReportComponent {...props} />;
}

export default SingleReport;
